import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import {
  ArrowTopRightOnSquareIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";
import CustomButton from "./CustomButton";
import { replace } from "lodash";

export default function Notification({
  show,
  setShow,
  status,
  errorMessage,
  isExport,
  button,
}) {
  // const [show, setShow] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setShow(false);
    }, 10000);
  });

  const handleNavigate = () => {
    navigate("/MyDocuments");
  };
  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="pointer-events-none mt-12 fixed inset-0 flex items-start px-4 py-6 sm:items-start sm:p-6 z-50"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            enter="transition ease-out duration-300"
            enterFrom="opacity-0 translate-y-2 sm:translate-y-0 sm:translate-x-2"
            enterTo="opacity-100 translate-y-0 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100 translate-y-0 sm:translate-x-0"
            leaveTo="opacity-0 translate-y-2 sm:translate-y-0 sm:translate-x-2"
          >
            <div
              className={`pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg ${
                status === "export" ? "bg-export-bg" : "bg-white"
              } shadow-lg ring-1 ring-black ring-opacity-5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0`}
            >
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    {status === "success" ? (
                      <CheckCircleIcon
                        className="h-6 w-6 text-custom-success-color"
                        aria-hidden="true"
                      />
                    ) : status === "warning" ? (
                      <ExclamationCircleIcon
                        className="h-6 w-6 text-custom-warning-color"
                        aria-hidden="true"
                      />
                    ) : status === "export" ? (
                      <span></span>
                    ) : (
                      <XCircleIcon
                        className="h-6 w-6 text-custom-error-color"
                        aria-hidden="true"
                      />
                    )}
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p
                      className={
                        status === "success"
                          ? "text-custom-success-color"
                          : status === "warning"
                          ? "text-custom-warning-color"
                          : status === "export"
                          ? "black"
                          : "text-custom-error-color"
                      }
                      style={{ marginTop: "-3px" }}
                    >
                      {status === "success"
                        ? "Success"
                        : status === "warning"
                        ? "Warning"
                        : status === "export"
                        ? "Success"
                        : "Error"}
                    </p>

                    {button && (
                      <div className="mt-3">
                        <CustomButton
                          color="bg-blue-600"
                          size="text-base"
                          weight="font-normal"
                          height="h-9"
                          width="w-36"
                          textColor="text-white"
                          text={"View"}
                          onClick={() => handleNavigate()}
                        />
                      </div>
                    )}
                    <p className="mt-1 text-base text-gray-500">
                      {errorMessage}{" "}
                      {isExport && (
                        <span
                          className="font-bold text-track-color cursor-pointer"
                          onClick={() =>
                            navigate("/export-history", { replace: true })
                          }
                        >
                          <span className="inline-flex items-center">
                            Track export in Export Audit{" "}
                            <ArrowTopRightOnSquareIcon className="w-5 h-5" />
                          </span>
                        </span>
                      )}
                    </p>
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                    <button
                      type="button"
                      className={`inline-flex rounded-md ${
                        status === "export" ? "bg-export-bg" : "bg-white"
                      } text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
}
